import React from 'react';
import { inject, observer } from 'mobx-react';
import ArtworkCard from '../cardHolders/artworksCard'
import ArtistCard from '../cardHolders/artistsCard';
// import '../../assets'
import { Redirect } from 'react-router-dom';
var qs = require('qs')

@inject('userStore', 'navigatorStore', 'authStore', 'landingPageArtworksStore', 'artworksStore', 'artistDetails', 'categoryPageArtworksStore')
@observer
export default class CategorySection extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    handleViewAll(kw, name, followingArtists) {
        if (followingArtists) {
            this.props.categoryPageArtworksStore.setQuery({ following: "True" }, name)
            this.setState({
                query: qs.stringify({ following: "True" }),
                viewAll: true,
                title: name
            })
        } else {
            this.props.categoryPageArtworksStore.setQuery({ search: kw }, name)
            this.setState({
                query: qs.stringify({ search: kw }),
                viewAll: (this.props.artistSection) ? false : true,
                viewAllArtists: (this.props.artistSection) ? true : false,
                title: name,
                artistKeyword: (this.props.artistSection) ? kw : false
            })
        }


    }

    render() {
        //  if( this.props.background)  var bg=require(`../../assets/watercolor_category.png`)
        if (this.props.background) var bg = require(`../../assets/${this.props.assetName}`)
        if (this.state.viewAll) {
            return (
                <Redirect push to={{ pathname: `/categorypoducts/${this.state.query}/${this.state.title}` }} />
            )
        }

        if (this.state.viewAllArtists) {
            return (
                <Redirect push to={{ pathname: `/allartists/${this.state.artistKeyword}/${this.state.title}` }} />
            )
        }
        if (this.state.viewAllArtistsCountry) {
            return (
                <Redirect push to={{ pathname: `/allartists/country/${this.state.country}/country` }} />
            )
        }
        if (this.props.background) {
            return (
                <div className="items-for-the-living-room" style={{ backgroundImage: "url(" + bg + ")" }}>
                    <div className="artwork-block width-90percent">
                        <div style={{ display: "flex" }}>
                            <div className="title-featured-artworks mt-85 ml-15 ">
                                {this.props.title}
                                <hr className="line-category-name "></hr>
                            </div>
                            <div className="d-none d-sm-block col-md-6 text-right mt-85">
                                <button onClick={() => this.handleViewAll(this.props.keyword, this.props.title)} className="view-all-btn">
                                    <span>View All</span>
                                </button>
                            </div>
                        </div>
                        <p className="heading-desc-text">
                            {

                                this.props.followingArtists && !this.props.artworkData.length ? "You are currently not following any Artist" : ""}
                        </p>
                        <p className="heading-desc-text">
                            {
                                this.props.short_desc
                               }
                        </p>
                        <section ref={this.myref} className="scroll-x-section mt-30 mb-15 pb-15">
                            <div className="col-md-12 no-padding">
                                <div className="mt-15 mb-15 pb-15">
                                    <ArtworkCard artworkData={this.props.artworkData} />
                                </div>
                            </div>
                        </section>

                        <div className="d-block d-sm-none text-right btn-small-screen m-40">
                            <button onClick={() => this.handleViewAll("living_room")} className="view-all-btn">
                                <span>View All</span>
                            </button>
                        </div>

                    </div>
                </div>)

        } else if (this.props.colored) {
            return (
                <div className="container-rectangle-colored" ref={this.artistsRef} >
                    <div className="rectangle-colored">

                        <div style={{ display: "flex" }}>
                            <div className="title-featured-artworks mt-15">
                                {this.props.title}
                                <hr className="line-category-name"></hr>
                                <p className="heading-desc-text">
                                    {

                                        this.props.followingArtists && !this.props.artworkData.length ? "You are currently not following any Artist" : ""}
                                </p>
                                <p className="heading-desc-text">
                                    {
                                        this.props.short_desc
                                    }
                                </p>
                            </div>
                            <div className="col-md-6 mt-15 text-right d-none d-sm-block">
                                <button onClick={() => this.handleViewAll(this.props.keyword, this.props.title, this.props.followingArtists)}
                                    style={{ display: (this.props[this.props.artistSection ? "artistData" : "artworkData"] && this.props[this.props.artistSection ? "artistData" : "artworkData"].length) ? "" : "none" }}
                                    className="view-all-btn">
                                    <span>View All</span>
                                </button>
                            </div>
                        </div>

                        <div className="mt-25 mb-15 pb-15">
                            {
                                this.props.artistSection ?
                                    <ArtistCard artistData={this.props.artistData} />
                                    :
                                    <ArtworkCard artworkData={this.props.artworkData} />
                            }
                        </div>

                        <div className="d-block d-sm-none text-right btn-small-screen m-40">
                            <button onClick={() => this.handleViewAll(this.props.keyword, this.props.title, this.props.followingArtists)}
                                style={{ display: (this.props[this.props.artistSection ? "artistData" : "artworkData"] && this.props[this.props.artistSection ? "artistData" : "artworkData"].length) ? "" : "none" }}
                                className="view-all-btn">
                                <span>View All</span>
                            </button>
                        </div>

                    </div>
                </div>
            )
        } else {
            return (
                <div className="rectangle-featured-artworks" ref={(section) => {
                    this.artworks = section;
                }}>
                    <div style={{ display: "flex" }}>
                        <div className="title-featured-artworks mt-15" style={{ margin: "unset", flex: "1" }}>
                            {this.props.title}
                            <hr className="line-category-name "></hr>
                            <p className="heading-desc-text">
                                {

                                    this.props.followingArtists && !this.props.artworkData.length ? "You are currently not following any Artist" : ""}
                            </p>
                            <p className="heading-desc-text">
                                {
                                    this.props.short_desc
                                }
                            </p>
                        </div>
                        <div className="col-md-6 mt-15 text-right d-none d-sm-block">
                            <button
                                style={{ display: (this.props[this.props.artistSection ? "artistData" : "artworkData"] && this.props[this.props.artistSection ? "artistData" : "artworkData"].length) ? "" : "none" }}
                                onClick={() => this.handleViewAll(this.props.keyword, this.props.title, this.props.followingArtists)} className="view-all-btn">
                                <span>View All</span>
                            </button>
                        </div>
                    </div>

                    <div className="mt-25 mb-15 pb-15">
                        {
                            this.props.artistSection ?
                                <ArtistCard artistData={this.props.artistData} />
                                :
                                <ArtworkCard artworkData={this.props.artworkData} />
                        }
                    </div>

                    <div className="d-block d-sm-none text-right btn-small-screen m-40">
                        <button style={{ display: (this.props[this.props.artistSection ? "artistData" : "artworkData"] && this.props[this.props.artistSection ? "artistData" : "artworkData"].length) ? "" : "none" }}
                            onClick={() => this.handleViewAll(this.props.keyword, this.props.title, this.props.followingArtists)} className="view-all-btn">
                            <span>View All</span>
                        </button>
                    </div>

                </div>
            )
        }

    }
}


// WEBPACK FOOTER //
// ./src/components/sectionHolders/artistsAndArtworksCardSection.js